export default "__VITE_ASSET__XCzbrHBK__"